import './legacy';
import './polyfills/hidden';
import './modules/sticky-header';
import './modules/home-carousel';
import './modules/hero-gallery';
import './modules/draws';
import './modules/filter';
import './modules/billing-address';
import './modules/booking-bar/index';
import './modules/nav-list';
import './modules/forms';
import './modules/quick-jump';
import './modules/product-filter';
import './modules/product-tabs';
import './modules/add-to-basket';
import './modules/update-cart';
import './modules/commerce-header-a11y';
import './modules/commerce/product-variants';
import './modules/commerce/product-ajax';
import { init as carousel } from './modules/commerce/product-index';
import { init as orderItems } from './modules/order-summary';
import { init as groceryShippingMethod } from './modules/grocery-shipping-method';
import { init as spinbutton } from './modules/spinbutton';
import { init as billingAddress } from './modules/billing-address';
import { domapi } from '@rynpsc/dialog';
import LazyLoader from './modules/lazy-loader';

init();

function init() {
	carousel();
	orderItems();
	groceryShippingMethod();
	billingAddress();
	spinbutton();
	domapi();
	LazyLoader().update();

	const accordion = document.querySelectorAll('.accordion-toggle');

	accordion.forEach(element => {
		const wrapper = element.nextElementSibling;

		element.addEventListener('click', function() {
			if (element.classList.contains('open')) {
				element.classList.remove('open');
				wrapper.classList.add('hidden');
			} else {
				element.classList.add('open');
				wrapper.classList.remove('hidden');
			}
		});
	});
}

// Calendar popout
const event = document.querySelectorAll('.event-marker .heading');
const popups = document.querySelectorAll('.popup');

event.forEach(element => {
	element.addEventListener('click', function(e) {
		const popup = element.nextElementSibling;

		e.preventDefault();

		popups.forEach(p => {
			p.style.opacity = 0;
			p.style.pointerEvents = 'none';
		});

		popup.style.opacity = 1;
		popup.style.pointerEvents = 'auto';
	});
});

document.addEventListener('click', function(e) {
	const isClickInside = e.target.closest('.event-marker') || e.target.closest('.popup');

	if (!isClickInside) {
		popups.forEach(p => {
			p.style.opacity = 0;
			p.style.pointerEvents = 'none';
		});
	}
});

// Sliders
if (typeof Swiper !== 'undefined') {
	const detailSliderThumbs = new Swiper('.detailSliderThumbs', {
		slidesPerView: 'auto',
		watchSlidesProgress: true,
		direction: 'vertical',
	});

	new Swiper('.detailSlider', {
		spaceBetween: 10,
		thumbs: {
			swiper: detailSliderThumbs,
		},
	});

	new Swiper('.featureSlider', {
		slidesPerView: 'auto',
		spaceBetween: 16,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	});
}
